<app-header *ngIf="identity"></app-header>
<app-header-mobile *ngIf="identity"></app-header-mobile>
<app-header-promotion *ngIf="identity"></app-header-promotion>

<router-outlet></router-outlet>

<!-- <app-newletter></app-newletter> -->
<app-footer *ngIf="identity"></app-footer>
